<template>
  <div>
    <template v-for="value in menuData">
      <template v-if="value.children.length > 0">
        <el-submenu :key="value.id" :index="value.id">
          <template slot="title">
            <span slot="title">{{ value.label }}</span>
          </template>
          <MenuTree :menu-data="value.children" />
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item
          :key="value.id"
          :index="value.index == '' ? value.id : value.index"
          @click="getMenuCode(value)"
        >
          <span slot="title"
            >{{ value.label }}
            <img
              v-if="!value.attributes.isFavorite"
              @click.stop="collection(value)"
              src="../assets/collection.svg"
              alt=""
              class="collection-icon"
            />
            <img
              v-else
              @click.stop="collection(value)"
              src="../assets/collection-select.svg"
              alt=""
              class="collection-icon"
            />
          </span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import bus from '../common/js/bus';
  export default {
    name: 'MenuTree',
    props: {
      menuData: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      collection(value) {
        let params = {
          name: value.label,
          path: value.index,
          menuCode: value.id,
        };
        this.$axios.post('/maindata/favorite/saveFavorite', params).then((res) => {
          if (res.data.code === 0) {
            bus.$emit('collection');
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
          }
        });
      },
      // 获取菜单code 查询按钮权限时用到
      getMenuCode(item) {
        this.userInfo.userInfo.menuCode = item.id;
        this.$store.commit('saveUserInfo', this.userInfo.userInfo);
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-submenu__title {
    border-left: 4px solid transparent;
  }
  ::v-deep .el-menu-item {
    border-left: 4px solid transparent;
  }

  .el-menu--collapse > .el-submenu > .el-submenu__title {
    width: 16px;
  }
  .el-submenu {
    width: 16px;
  }

  .collection-icon {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .el-menu--popup {
    .collection-icon {
      top: 4px;
      color: #1a70ff;
    }
  }
</style>
